// extracted by mini-css-extract-plugin
export default {"sliderCard":"SliderCard_sliderCard__wTesD","sliderCard_box":"SliderCard_sliderCard_box__BuVTo","sliderCard_author":"SliderCard_sliderCard_author__YKdt5"};